<template lang="pug">
.activities-location-reset-zoom-control(@click="$emit('click')")
  i.hi.hi-users(title="Reset zoom")
</template>

<script>
export default {
  name: 'ActivitiesLocationResetZoomControl',
};
</script>
